import { headers } from './constants';
import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import Identity from './identity';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

/**
 * Intended to be used as a callback to the user action like `onclick` to a custom "Sign in with Apple" button.
 *
 * When used as a response to a user action (onclick) event, this function will prompt the user to login to Apple if they have not already done so.
 *
 */

export const initAppleSignOn = async (): Promise<APIErrorResponse | void> => {
  return fetch(`${Identity.apiOrigin}/identity/public/v1/apple/authurl`, {
    method: 'GET',
    cache: 'no-cache',
    headers: { ...headers }
  })
    .then(JSONResponseHandler)
    .then(res => {
      if (isAPIErrorResponse(res)) {
        throw res;
      } else {
        const redirect = encodeURIComponent(`${Identity.apiOrigin}/identity/public/v1/apple/auth`);
        window.location.href = `${res}&redirect_uri=${redirect}`;
      }
    });
};

export default initAppleSignOn;
